class SliderImg extends HTMLElement {
  constructor() {
    super();
    this.swiperDesktop = null;
    this.swiperMobile = null;
  }

  connectedCallback() {
    this.initSliders();
  }

  initSliders() {
    const desktopEl = this.querySelector('.swiper-img');
    const mobileEl  = this.querySelector('.swiper-img2');

    const navWrap   = this.querySelector('.slider-img__navigation');
    const prevBtn   = navWrap?.querySelector('.swiper-button-prev') || null;
    const nextBtn   = navWrap?.querySelector('.swiper-button-next') || null;
    const pagination= navWrap?.querySelector('.swiper-pagination')   || null;

   if (desktopEl) {
    this.swiperDesktop = new Swiper(desktopEl, {
      slidesPerView: 1.8,
      spaceBetween: 6,
      loop: true,
      initialSlide: 1,
      navigation: (prevBtn && nextBtn) ? { prevEl: prevBtn, nextEl: nextBtn } : undefined,
      pagination: pagination ? { el: pagination, clickable: true } : undefined,
      on: {
        init(swiper) { swiper.slideToLoop(1, 0); }
      },
      breakpoints: {
        1200: {
          slidesPerView: 'auto',
          spaceBetween: 18,
          loop: false,
          initialSlide: 1
        }
      }
    });
  }


    if (mobileEl) {
      this.swiperMobile = new Swiper(mobileEl, {
        slidesPerView: 1.8,
        spaceBetween: 6,
        loop: true,
        centeredSlides: true,
        breakpoints: { 989: { slidesPerView: 4.5, spaceBetween: 6 } }
      });
    }
  }
}

customElements.define('slider-img', SliderImg);
